import { Vue, Component } from 'vue-property-decorator';
import { NoticeCategoryData } from '@/types';
import { toI18n } from '@/utils/commonUtils';

@Component
export default class NoticeCategory extends Vue {
  public noticeCategoryData: NoticeCategoryData[] = [
    { value: '', label: this.toI18n('BOARD_MIXINS_ALL') },// 전체
    { value: 'GENERAL', label: this.toI18n('BOARD_MIXINS_NORMAL') },// 일반
    { value: 'PROMOTION', label: this.toI18n('BOARD_MIXINS_PROMOTION_NOTICE') },// 프로모션 공지
    { value: 'WARNING', label: this.toI18n('BOARD_MIXINS_HAZARD_INFORMATION') },// 위해정보
    { value: 'SAFETY_TRADE', label: this.toI18n('BOARD_MIXINS_SAFE_TRANSACTION') },// 안전거래
    { value: 'SYSTEM', label: this.toI18n('BOARD_MIXINS_SYSTEM') }// 시스템
  ];

  public getNoticeCategory(noticeCategory: string): string {
    return (
      this.noticeCategoryData.find((category: NoticeCategoryData): {} => {
        return category.value === noticeCategory;
      }) || { value: '', label: this.toI18n('BOARD_MIXINS_ALL') }
    ).label; // 전체
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}